  const swiper = new Swiper(".swiper-container.brndslider", {
    // Optional parameters
    direction: "horizontal",

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });